export const currencyFormat = {
    withSymbol: '$0,0.00',
    withoutSymbol: '0,0.00',
};
